"use client";

import { useEffect } from "react";
import Image from "next/image";
import { faroManager } from "@/lib/client/faro-manager";
import { clientLogger } from "@/lib/logger";

export default function Error({
	error,
}: {
	error: Error & { digest?: string };
}) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	useEffect(() => {
		if (!error) {
			return;
		}

		const eventAttributes = {
			page: "global_error_page",
			digest: error.digest ?? "",
			message: error.message ?? "",
		};

		faroManager.pushEvent("app.error_page_viewed", eventAttributes);
		clientLogger.info("[ErrorBoundary] error page viewed", eventAttributes);
	}, [error]);

	return (
		<div className="flex flex-col items-center justify-center p-10 md:p-32 bg-white text-center ">
			<div className="max-w-xl w-full">
				{/* Space for SVG - you can add your custom SVG here */}
				<div className="flex justify-center mb-4">
					<Image
						src="/new_icons/general/error-page-icon.svg"
						alt="Error icon"
						width={225}
						height={225}
					/>
				</div>

				{/* Main heading with blue border box */}

				<h1 className="text-xl md:text-[24px] text-automint-black">
					Plot twist: unexpected breakdown
				</h1>

				{/* Description text */}
				<p className="text-gray-600 text-sm max-w-md mx-auto">
					Our engineers are under the hood trying to figure out which wire got
					crossed. Refresh in a bit while we frantically consult the manual.
				</p>
			</div>
		</div>
	);
}
